import validator from 'email-validator';

export default {
  isEmail(value) {
    return validator.validate(value);
  },
  isPassword(value) {
    if (value == null) return false;
    return /^[0-9a-zA-Z]{8,}$/.test(value);
  },
  isCellphone(value) {
    return /^\d{6,}$/.test(value);
  },
  isUserName(value) {
    if (value == null) return false;
    return value.trim().length > 0;
  },
  isNotEmpty(value) {
    if (value == null) return false;
    return value.trim().length > 0;
  },
};
